import { render } from "./InputFile.vue?vue&type=template&id=6adf94f6&scoped=true"
import script from "./InputFile.vue?vue&type=script&lang=js"
export * from "./InputFile.vue?vue&type=script&lang=js"

import "./InputFile.vue?vue&type=style&index=0&id=6adf94f6&lang=scss&scoped=true"

import exportComponent from "D:\\LTG Sercices\\SUP-H\\suph-adhesion-pro\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6adf94f6"]])

export default __exports__